import { UrlMatchResult, UrlSegment } from '@angular/router';
import { ENTITY_TYPE } from '../../../shared/typings/types/entity-type.types';

export const SUPPORTED_ENTITY_TYPES = [ENTITY_TYPE.SCHOOL, ENTITY_TYPE.SHELTER];

export function entityTypeMatcher (segments: UrlSegment[]): UrlMatchResult | null {
  if (segments.length > 0 && SUPPORTED_ENTITY_TYPES.includes(segments[0].path as ENTITY_TYPE)) {
    const [entityType] = segments;
    return { consumed: [entityType], posParams: { entityType } };
  }
  return null;
}
